export enum DictionaryGroup {
  TestStatus = 'test-status',
  TestType = 'test-type',
  AnswerType = 'answer-type',
}
